import type { Content, TalentEffect } from '../../data/schema';

/** Nombre à la française : arrondi à 2 décimales (pas de 0,44999…), virgule décimale. */
function num(n: number): string {
  return String(Math.round(n * 100) / 100).replace('.', ',');
}
const plural = (n: number, one: string, many: string): string => (Math.abs(n) > 1 ? many : one);

/**
 * Lignes lisibles d'une liste d'effets de talent, multipliées par `rank` (rang possédé pour « Effet cumulé », 1 pour « Prochain rang »).
 * `startItem` et `startSpell` ne dépendent pas du rang.
 */
export function describeEffects(effects: readonly TalentEffect[], rank: number, content: Pick<Content, 'spells'>): string[] {
  return effects.map((e) => {
    switch (e.type) {
      case 'startItem': return `Objet de départ : ${e.slot}`;
      case 'startSpell': return `Sort initial : ${content.spells[e.spellId]?.name ?? e.spellId}`;
      default: break;
    }
    const v = e.value * rank;
    switch (e.type) {
      case 'hpFlat': return `+${num(v)} PV`;
      case 'hpPct': return `+${num(v)} % PV`;
      case 'damagePct': return `+${num(v)} % dégâts`;
      case 'kamasPct': return `+${num(v)} % Kamas`;
      case 'rerolls': return `+${num(v)} ${plural(v, 'relance', 'relances')}`;
      case 'shopDiscountPct': return `-${num(v)} % prix marchand`;
      case 'cooldownPct': return `-${num(v)} % recharge`;
      case 'speedPct': return `+${num(v)} % vitesse`;
      case 'xpPct': return `+${num(v)} % XP`;
      case 'startKamas': return `+${num(v)} Kamas au départ`;
      case 'pickupRange': return `+${num(v)} px de ramassage`;
      case 'shopRerollFree': return `+${num(v)} ${plural(v, 'relance gratuite', 'relances gratuites')} au marchand`;
      case 'rewindCooldown': return `-${num(v)} s de recharge par monstre tué`;
      case 'slowBonusPct': return `+${num(v)} % de ralentissement`;
      case 'startLevel': return `+${num(v)} ${plural(v, 'niveau', 'niveaux')} de départ`;
      case 'refletsPct': return `+${num(v)} % Reflets`;
      case 'shieldOnRoom': return `+${num(v)} de bouclier à chaque salle`;
      case 'bossDamagePct': return `+${num(v)} % dégâts sur le boss`;
    }
  });
}
